"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIO = void 0;
const toCompactVerbosity_1 = require("./toCompactVerbosity");
const parseIO = (io, verbosity) => {
    if (verbosity === "compact") {
        const compact = (0, toCompactVerbosity_1.toCompactVerbosity)(io);
        if (compact.success) {
            return compact.data;
        }
    }
    return io;
};
exports.parseIO = parseIO;
